import { Url } from '../../types';
import { workflowSchema } from '../models/workflow.schema';

export const get = (workflowUrl: Url) => {
  return {
    endpoint: workflowUrl,
    method: 'GET',
    responseSchema: workflowSchema,
  } as const;
};
